import React from "react";
import styled from "@emotion/styled";
import Button from "../Button";
import Link from "next/link";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";

interface IAgentsCollectionCardLight {
  picture: string;
  name: string;
  agencia: string;
  id: number;
}
function AgentCollectionCardLight(props: IAgentsCollectionCardLight) {
  const translation = useTranslations("collection.certifiedAgents");

  return (
    <ContentCard>
      <ContainerCard>
        <ContainerImg>
          <UserImage src={props.picture} alt={props.name + "-" + props.id} />
        </ContainerImg>
        <LabelName>{props.name}</LabelName>
        <LabelSubtitle>
          {translation("agentOf")} {props.agencia}
        </LabelSubtitle>
      </ContainerCard>
      <ContainerButton>
        <Link
          href={
            CPagesPath.es.collection_agent_detail({
              id: props.id,
              name: props.name,
            }) +
            "?referer=" +
            props.id
          }
          passHref
        >
          <Button component={"a"} bg="--bg-secondary">
            {translation("seeAgent")}
          </Button>
        </Link>
      </ContainerButton>
    </ContentCard>
  );
}

export default AgentCollectionCardLight;

const ContentCard = styled.div`
  width: 80%;
  background: transparent;
  margin: 0 auto;
  @media screen and (max-width: 500px) {
    width: 90%;
    margin: auto;
  }
`;

const ContainerCard = styled.div`
  border-radius: 13px;
  text-align: center;
  width: 100%;
  min-height: 220px;
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
`;

const ContainerImg = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const LabelName = styled.span`
  font-family: var(--font-family);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  display: block;
  color: var(--text-black);
  margin-top: 10px;
`;

const LabelSubtitle = styled.span`
  font-family: var(--font-family);
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  display: block;
  color: var(--color-brand-grey-secondary);
  margin-top: 5px;
`;

const UserImage = styled.img`
  width: 130px;
  height: 130px;
  border-radius: 100%;
  object-fit: contain;
`;
